export default [
    {
        key: 'specificationModal',
        getComponent: function () { return import('./SpecificationModal'); },
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal select-member-modal',
    },
    {
        key: 'BatchSettingModal',
        getComponent: function () { return import('./BatchSettingModal'); },
        title: i18n.get('批量下发'),
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal',
    },
    {
        key: 'LogModal',
        getComponent: function () { return import('./LogModal'); },
        title: '下发记录',
        width: 800,
    },
    {
        key: 'SettingPop',
        getComponent: function () { return import('./SettingPop'); },
        width: 400,
        title: '',
        maskClosable: false,
        timeout: 500,
    },
];
